import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LayoutService } from '../../../services/layout.service';

@Component({
  selector: 'col-2-2-1',
  templateUrl: './col-2-2-1.component.html',
  styleUrls: ['./col-2-2-1.component.scss'],
})
export class Col221Component implements OnChanges {
  @Input() index: any;
  @Input() templates: any;
  @Input() footer: any;
  @Input() edit: boolean;
  @Output() component = new EventEmitter<any>();
  matchmedia_height: number;
  matchmedia_width: number;
  componentData: any = [];

  Footer = [
    {
      typeOf: 'cta',
      height: '100vh',
      width: '95vw',
      value: 'cta',
      name: 'Call to Action',
      selected: false,
    },
    {
      typeOf: 'text',
      height: '95vh',
      width: '90vw',
      value: 'text',
      name: 'Text Block',
      selected: false,
    },
    {
      typeOf: 'image',
      height: '95vh',
      width: '90vw',
      value: 'image',
      name: 'Image Block',
      selected: false,
    },
  ];

  Components = [
    {
      typeOf: 'cta',
      height: '100vh',
      width: '95vw',
      value: 'cta',
      name: 'Call to Action',
      selected: false,
    },
    {
      typeOf: 'image',
      height: '95vh',
      width: '90vw',
      value: 'image',
      name: 'Image Block',
      selected: false,
    },
    {
      typeOf: 'showcase-list',
      height: '95vh',
      width: '80vw',
      value: 'showcase-list',
      name: 'List Carousel',
      selected: false,
      dynamic: false,
    },
    {
      typeOf: 'showcase',
      height: 'auto',
      width: '80vw',
      value: 'showcase',
      name: 'Showcase Carousel',
      selected: false,
      dynamic: true,
    },
    {
      typeOf: 'popular-list',
      height: '95vh',
      width: '80vw',
      value: 'popular-list',
      name: 'Popular Carousel',
      selected: false,
      dynamic: false,
    },
    {
      typeOf: 'feedback',
      height: '95vh',
      width: '90vw',
      value: 'feedback',
      name: 'Feed Back',
      selected: false,
    },
    {
      typeOf: 'text',
      height: '95vh',
      width: '90vw',
      value: 'text',
      name: 'Text Block',
      selected: false,
    },
    {
      typeOf: 'topic',
      height: '85vh',
      width: '90vw',
      value: 'topic',
      name: 'Topic Search',
      selected: false,
    },
    {
      typeOf: 'embed',
      height: '85vh',
      width: '90vw',
      value: 'embed',
      name: 'Embed Web Link',
      selected: false,
    },
  ];

  constructor(
    public dialog: MatDialog,
    private _layoutService: LayoutService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    // swap the component json with footer json if its footer
    if (changes) {
      if (changes.index) {
        this.index = changes.index.currentValue;
      }
      if (changes.footer) {
        this.footer = changes.footer.currentValue;
        if (this.footer == 'true') {
          this.Components = this.Footer;
        }
      }
    }
  }

  openSideNav(typeOf, compArray, template, row, edit) {
    if (typeOf != 0) {
      let data = null;
      if (typeOf === 'showcase') {
        // for regular dynamic showcase
        data = {
          typeOf: typeOf,
          rowType: row,
          rowArray: this.index,
          compArray: compArray,
          template: template,
          edit: edit,
          dynamic: true,
        };
      } else if (typeOf === 'showcase-list') {
        // for list showcase
        data = {
          typeOf: 'showcase-list',
          rowType: row,
          rowArray: this.index,
          compArray: compArray,
          template: template,
          edit: edit,
          dynamic: false,
        };
      } else if (typeOf === 'popular-list') {
        // for list showcase
        data = {
          typeOf: 'popular-list',
          rowType: row,
          rowArray: this.index,
          compArray: compArray,
          template: template,
          edit: edit,
          dynamic: false,
        };
      } else {
        // for all other conditions
        data = {
          typeOf: typeOf,
          rowType: row,
          rowArray: this.index,
          compArray: compArray,
          template: template,
          edit: edit,
          //  dynamic:false
        };
      }
      if (data) {
        this._openSideNav(data);
      }
    }
  }

  private _openSideNav(data) {
    this._layoutService.openSideNav({
      template: 'comp',
      position: 'start',
      data: data,
      mode: 'side',
    });
  }

  getWithOutIndex(num1, num2) {
    const indexes = [];
    for (let i = 0; i < this.Components.length; i++) {
      if (i != num1 && i != num2) {
        indexes.push(this.Components[i]);
      }
    }
    return indexes;
  }
}
